import { useCheckIsB2BEnrichment } from '@aibees/shared/hooks';
import {
  ENTITLEMENT_ROOT_ENDPOINT,
  INVOICE_ROOT_ENDPOINT,
  INVOICE_ROOT_ENDPOINT_B2B_ENRICHMENT,
  PAYMENT_METHOD_ROOT_ENDPOINT,
  PAYMENT_METHOD_ROOT_ENDPOINT_B2B_ENRICHMENT,
  SUBSCRIPTION_ROOT_ENDPOINT,
  SUBSCRIPTION_ROOT_ENDPOINT_B2B_ENRICHMENT,
  SUBSCRIPTION_ROOT_ENDPOINT_WITH_ID,
  SUBSCRIPTION_ROOT_ENDPOINT_WITH_ID_B2B_ENRICHMENT,
} from '../constants/endpoints';
import { useWorkspace } from '../context';

export function useCustomerEndpoint(key: keyof typeof ENDPOINTS) {
  const isEnrichment = useCheckIsB2BEnrichment();

  const ENDPOINTS = {
    entitlement: ENTITLEMENT_ROOT_ENDPOINT,
    subscription: isEnrichment
      ? SUBSCRIPTION_ROOT_ENDPOINT_B2B_ENRICHMENT
      : SUBSCRIPTION_ROOT_ENDPOINT,
    subscriptionWithId: isEnrichment
      ? SUBSCRIPTION_ROOT_ENDPOINT_WITH_ID_B2B_ENRICHMENT
      : SUBSCRIPTION_ROOT_ENDPOINT_WITH_ID,
    paymentMethod: isEnrichment
      ? PAYMENT_METHOD_ROOT_ENDPOINT_B2B_ENRICHMENT
      : PAYMENT_METHOD_ROOT_ENDPOINT,
    invoice: isEnrichment
      ? INVOICE_ROOT_ENDPOINT_B2B_ENRICHMENT
      : INVOICE_ROOT_ENDPOINT,
  };

  const wid = useWorkspace()?.id;

  return ENDPOINTS[key].replace(':customerId', String(wid));
}
